export default "__VITE_ASSET__BRndHcbe__"